import { EventBus, EventKeys } from '@blade/common';
import store from '@blade-sxp/screen/store/index';
export default {
    methods: {
        closeImmersionFn() {
            store.updateIsImmersion(false);
            store.updateIsShow(true);
            store.updateIsShowToolOperation(false);
            EventBus.$emit(EventKeys.IS_SHOW_OPERATION, {
                class: ''
            });
        },
        onListClick() {
            store.updateIsShowToolOperation(!store.isShowToolOperation);
            EventBus.$emit(EventKeys.IS_SHOW_OPERATION, {
                class: 'immersion-tools'
            });
        }
    }
};
